import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getAwscCallRequest = (query, params) =>
  restRequest({
    uri: 'awscCall',
    query,
    method: HttpMethods.Get,
    ...params,
  });
